import { OptionsObject, ProviderContext, useSnackbar } from "notistack";

interface IUseToast {
  success: (message: string, opt?: OptionsObject) => void;
  error: (message: string, opt?: OptionsObject) => void;
  info: (message: string, opt?: OptionsObject) => void;
  custom: (message: string, opt?: OptionsObject, component?: any) => void;
  snackbar: ProviderContext;
}

const useToast = (): IUseToast => {
  const snackbar = useSnackbar();

  const optionsCommon = {
    autoHideDuration: 3000,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  } as any;

  const success = (message: string, opt?: OptionsObject) => {
    snackbar.enqueueSnackbar(message, {
      variant: "success",
      ...optionsCommon,
      ...opt,
      color: "#fff",
    });
  };

  const error = (message: string, opt?: OptionsObject) => {
    snackbar.enqueueSnackbar(message, {
      variant: "error",
      ...optionsCommon,
      ...opt,
    });
  };

  const info = (message: string, opt?: OptionsObject) => {
    snackbar.enqueueSnackbar(message, {
      variant: "info",
      ...optionsCommon,
      ...opt,
    });
  };

  const custom = (message: string, opt?: OptionsObject, component?: any) => {
    snackbar.enqueueSnackbar(message, {
      variant: "info",
      ...optionsCommon,
      ...opt,
      content: component,
    });
  };

  return {
    success,
    error,
    info,
    custom,
    snackbar,
  };
};

export default useToast;
